<template>
  <div>
    <van-empty description="您还未开通账号，请联系客服开通" />
    <WxNoShare />
  </div>
</template>

<script>
  import { Empty } from 'vant';

  export default {
    components: {
      [Empty.name]: Empty,
    },
    name: 'AdminEmpty',
    data () {
      return {
        user: {}
      }
    },
    created () {

    },
    methods: {

    }
  }
</script>
<style scoped>

</style>
